<!-- 趴款看板 -->
<template>
  <div class="box">
    <div class="box_top">
      <div>
        显示具体数值：
        <a-switch v-model:checked="amountShowDetail" />
      </div>
      <div>
        时间：
        <a-date-picker v-model:value="time" :disabled-date="disabledDate" value-format="YYYY-MM-DD" @change="onDateRangeChange"/>
      </div>
    </div>
    <div class="box_item">
      <div class="item_title">
        <span>总体趴款</span>
      </div>
      <div class="ztpk_box">
        <div v-for="item in ztpkList" :key="item.key">
          <div class="img" :class="item.key"></div>
          <div class="text">
            <span>{{ item.name }}</span>
            <span>{{ formatAmount(ALL_PORT_DATA[item.key]) || 0 }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="box_item">
      <a-tabs v-model:activeKey="activeKey" @change="tabChange">
        <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.label">
          <div class="tab_text">
            <div v-for="el in item.list" :key="el.name" class="text_item">
              <span>{{ el.name }}</span>
              <span>{{ formatAmount(findDataByKey(item.dataKey)[el.key]) || 0 }}</span>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="box_item">
      <div class="item_title">
        <span>广告主公司</span>
        <div>
<!--          <div>
            <span>广告主公司id：</span>
            <a-input v-model:value="ggzgsid" placeholder="请输入广告主公司id" />
          </div>-->
          <div>
            <span>广告主公司名称：</span>
            <a-input
              v-model:value="ggzgsmc"
              placeholder="请输入广告主公司名称"
              @blur="getFlowDetailList"
              @pressEnter='getFlowDetailList'
            />
          </div>
        </div>
      </div>
      <div class="item_table">
        <a-table
          :loading='flowDetailListLoading'
          :columns="columns"
          row-key="dataIndex"
          :data-source="currentPageDataSource"
          :pagination="pagination"
          :scroll="{ x: 1300, y: 500 }"
          @change="handleTableChange"
        >
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';
import { getFundsFlowData, getFundsFlowDetailList } from '@/api/funds/index';
import { addChineseUnit } from '@/utils/utils.js';
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      amountShowDetail: true, // 显示具体数值
      time: '', // 时间
      ztpkList: [
        { name: '总趴款金额', key: 'all_balance' },
        { name: '昨日总趴款天数', key: 'yestoday_nocost_days' },
        { name: '总超3天无消耗账户趴款', key: 'no_cost_3' },
        { name: '昨日总消耗', key: 'yestoday_cost' },
        { name: '当月平均趴款总天数', key: 'avg_days' },
        { name: '总广告主预付余额', key: 'prepay_balance' },
        { name: '总共享钱包预付余额', key: 'wallet_prepay_balance' },
        { name: '总共享钱包授信余额', key: 'wallet_credit_balance' },
      ],
      ALL_PORT_DATA: {
        all_balance: '0',
        yestoday_nocost_days: '0',
        no_cost_3: '0',
        yestoday_cost: '0',
        avg_days: '0',
        prepay_balance: '0',
        wallet_prepay_balance: '0',
        wallet_credit_balance: '0'
      },
      //
      LM_PORT_DATA: {
        all_balance: '0',
        yestoday_nocost_days: '0',
        no_cost_3: '0',
        yestoday_cost: '0',
        avg_days: '0',
        prepay_balance: '0',
        wallet_prepay_balance: '0',
        wallet_credit_balance: '0'
      },
      QR_PORT_DATA: {
        all_balance: '0',
        yestoday_nocost_days: '0',
        no_cost_3: '0',
        yestoday_cost: '0',
        avg_days: '0',
        prepay_balance: '0',
        wallet_prepay_balance: '0',
        wallet_credit_balance: '0'
      },
      SDJ_PORT_DATA: {
        all_balance: '0',
        yestoday_nocost_days: '0',
        no_cost_3: '0',
        yestoday_cost: '0',
        avg_days: '0',
        prepay_balance: '0',
        wallet_prepay_balance: '0',
        wallet_credit_balance: '0'
      },
      LJ_PORT_DATA: {
        all_balance: '0',
        yestoday_nocost_days: '0',
        no_cost_3: '0',
        yestoday_cost: '0',
        avg_days: '0',
        prepay_balance: '0',
        wallet_prepay_balance: '0',
        wallet_credit_balance: '0'
      },
      activeKey: 'LM',
      tabList: [
        {
          label: '芦鸣',
          key: 'LM',
          dataKey: 'LM_PORT_DATA',
          list: [
            { name: '总趴款金额', key: 'all_balance' },
            { name: '昨日趴款天数', key: 'yestoday_nocost_days' },
            { name: '超3天无消耗账户趴款', key: 'no_cost_3' },
            { name: '昨日消耗', key: 'yestoday_cost' },
            { name: '当月平均趴款天数', key: 'avg_days' },
            { name: '广告主预付余额', key: 'prepay_balance' },
            { name: '共享钱包预付余额', key: 'wallet_prepay_balance' },
            { name: '共享钱包授信余额', key: 'wallet_credit_balance' }
          ]
        },
        {
          label: '洽尔',
          key: 'QR',
          dataKey: 'QR_PORT_DATA',
          list: [
            { name: '总趴款金额', key: 'all_balance' },
            { name: '昨日趴款天数', key: 'yestoday_nocost_days' },
            { name: '超3天无消耗账户趴款', key: 'no_cost_3' },
            { name: '昨日消耗', key: 'yestoday_cost' },
            { name: '当月平均趴款天数', key: 'avg_days' },
            { name: '广告主预付余额', key: 'prepay_balance' },
            { name: '共享钱包预付余额', key: 'wallet_prepay_balance' },
            { name: '共享钱包授信余额', key: 'wallet_credit_balance' }
          ]
        },
        {
          label: '芦剧',
          key: 'LJ',
          dataKey: 'LJ_PORT_DATA',
          list: [
            { name: '总趴款金额', key: 'all_balance' },
            { name: '昨日趴款天数', key: 'yestoday_nocost_days' },
            { name: '超3天无消耗账户趴款', key: 'no_cost_3' },
            { name: '昨日消耗', key: 'yestoday_cost' },
            { name: '当月平均趴款天数', key: 'avg_days' },
            { name: '广告主预付余额', key: 'prepay_balance' },
            { name: '共享钱包预付余额', key: 'wallet_prepay_balance' },
            { name: '共享钱包授信余额', key: 'wallet_credit_balance' }
          ]
        },
        {
          label: '圣达际',
          key: 'SDJ',
          dataKey: 'SDJ_PORT_DATA',
          list: [
            { name: '总趴款金额', key: 'all_balance' },
            { name: '昨日趴款天数', key: 'yestoday_nocost_days' },
            { name: '超3天无消耗账户趴款', key: 'no_cost_3' },
            { name: '昨日消耗', key: 'yestoday_cost' },
            { name: '当月平均趴款天数', key: 'avg_days' },
            { name: '广告主预付余额', key: 'prepay_balance' },
            { name: '共享钱包预付余额', key: 'wallet_prepay_balance' },
            { name: '共享钱包授信余额', key: 'wallet_credit_balance' }
          ]
        }
      ],
      // 表格
      flowDetailListLoading: true,
      ggzgsid: '',
      ggzgsmc: '',
      columns: [
        {
          title: '广告主公司id',
          dataIndex: 'company_id'
        },
        {
          title: '广告主公司名称',
          dataIndex: 'company_name',
          width: '320px'
        },
        {
          title: '趴款总金额',
          dataIndex: 'all_balance',
          sorter: (a, b) => a.all_balance- b.all_balance,
          defaultSortOrder: 'descend',
        },
        {
          title: '昨日趴款天数',
          dataIndex: 'yestoday_nocost_days',
          sorter: (a, b) => a.yestoday_nocost_days- b.yestoday_nocost_days,
          defaultSortOrder: 'descend',
        },
        {
          title: '超3天无消耗账户趴款',
          dataIndex: 'no_cost_3',
          sorter: (a, b) => a.no_cost_3- b.no_cost_3,
          defaultSortOrder: 'descend',
        },
        {
          title: '昨日消耗',
          dataIndex: 'cash_balance',
          sorter: (a, b) => a.cash_balance- b.cash_balance,
          defaultSortOrder: 'descend',
        },
        {
          title: '当月平均趴款天数',
          dataIndex: 'avg_days',
          sorter: (a, b) => a.avg_days- b.avg_days,
          defaultSortOrder: 'descend',
        },
        {
          title: '广告主预付余额',
          dataIndex: 'cash_cost', // ?
          sorter: (a, b) => a.cash_cost- b.cash_cost,
          defaultSortOrder: 'descend',
        }
      ],
      dataSource: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 20,
        showTotal: (total) => `共 ${total} 条记录`, // 显示总记录数
        showSizeChanger: true, // 是否可改变每页显示条数
        pageSizeOptions: ['10', '20', '50', '100','1000'], // 可选的每页显示条数
      }
    }
  },
  computed: {
    // 当前页数据（前端分页）
    currentPageDataSource () {
      if (!this.dataSource.length) return []
      return this.dataSource.slice((this.pagination.current - 1) * this.pagination.pageSize, this.pagination.current * this.pagination.pageSize)
    }
  },
  watch: {},
  mounted () {
    // 初始化
    this.init();
  },
  methods: {
    disabledDate(current) {
      return current && (current > moment().subtract(1, 'days').endOf('day') || current.valueOf() < moment('2024-07-01'));
    },
    // 初始化
    init () {
      this.time = moment().subtract(1, 'days').format('YYYY-MM-DD')
      this.getFlowData();
      this.getFlowDetailList();
    },
    // 开始时间结束时间选择
    onDateRangeChange(val, dateString) {
      this.ggzgsmc = ''
      this.getFlowData();
      this.getFlowDetailList();
    },
    tabChange() {
      this.getFlowDetailList();
    },
    async getFlowData() {
      let res;
      try {
        console.log(this.time)
        res = await getFundsFlowData(this.time);
        this.ALL_PORT_DATA = res.data.all || {}
        this.LM_PORT_DATA = res.data.LM || {}
        this.SDJ_PORT_DATA = res.data.SDJ || {}
        this.QR_PORT_DATA = res.data.QR || {}
        this.LJ_PORT_DATA = res.data.LJ || {}
      }catch (error) {

      }
    },
    async getFlowDetailList() {
      let res;
      const date = this.time
      const port = this.activeKey
      const companyName = this.ggzgsmc
      this.pagination.total = 0
      this.pagination.current = 1
      this.flowDetailListLoading = true
      try {
        res = await getFundsFlowDetailList(date,port,companyName);
        this.flowDetailListLoading = false
        this.dataSource = res.data || [];
        this.pagination.total = res.data.length;
      }catch (error) {

      }
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      pager.pageSize = pagination.pageSize;
      this.pagination = pager;
    },
    findDataByKey(key) {
      return this[key]
    },
    formatAmount(val) {
      if (this.amountShowDetail) {
        return val
      }
      if (val === 0) {
        val = '';
      }
      return addChineseUnit(val);
    },
  }
}
</script>

<style scoped>
.box {
  font-size: 12px;
  height: 100%;
}
.box .box_top {
  background: #fff;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.box .box_top > div {
  margin-left: 10px;
}
.box .box_item {
  margin-top: 10px;
  background: #fff;
  padding: 20px;
}
.box .box_item .item_title {
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: space-between;
}
.item_title > span {
  padding-left: 10px;
  border-left: 4px solid #2f70f4;
}
.item_title > div {
  display: flex;
  margin-bottom: 10px;
}
.item_title > div > div {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.item_title > div > div > span {
  flex-shrink: 0;
}
.ztpk_box {
  overflow: hidden;
}
.ztpk_box > div {
  float: left;
  display: flex;
  width: 360px;
  margin-top: 20px;
}
.ztpk_box > div .text {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.ztpk_box > div .text > span:first-child {
  font-size: 12px;
  color: #7f7f7f;
}
.ztpk_box > div .text > span:last-child {
  font-size: 18px;
  font-weight: bold;
}
.ztpk_box > div .img {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
}
.img.all_balance {
  background: #ebf1fe;
  background-image: url('img/all_balance.png');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
}
.img.yestoday_nocost_days {
  background: #fef5e9;
  background-image: url('img/yestoday_nocost_days.png');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
}
.img.no_cost_3 {
  background: #ebf1fe;
  background-image: url('img/no_cost_3.png');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
}
.img.yestoday_cost {
  background: #f0f6e6;
  background-image: url('img/yestoday_cost.png');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
}
.img.avg_days {
  background: #fef5e9;
  background-image: url('img/avg_days.png');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
}
.img.prepay_balance {
  background: #f3e6ff;
  background-image: url('img/prepay_balance.png');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
}
.img.wallet_prepay_balance {
  background: #f3e6ff;
  background-image: url('img/wallet_prepay_balance.png');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
}
.img.wallet_credit_balance {
  background: #f3e6ff;
  background-image: url('img/wallet_credit_balance.png');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
}
.tab_text .text_item {
  float: left;
  margin-top: 10px;
  min-width: 200px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-right: 1px solid #d7d7d7;
}
.tab_text .text_item > span:first-child {
  font-size: 12px;
  color: #7f7f7f;
}
.tab_text .text_item > span:last-child {
  font-size: 18px;
  font-weight: bold;
}
.tab_text .text_item:last-child {
  border-right: 0;
}
</style>
